import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const InputAppEndPoints = {
  GET_BCTX: 'GET_BCTX',
  SAVE_EVENT: 'SAVE_EVENT',
  RESTORE_APP_STATE: 'RESTORE_APP_STATE',
  TO_BE_RECTIFIED: 'TO_BE_RECTIFIED',
  RESTORE_TO_BE_RECTIFIED_COUNTS: 'RESTORE_TO_BE_RECTIFIED_COUNTS',
  ALL_MASTERDATA_LISTS: 'ALL_MASTERDATA_LISTS',
  UPDATE_INCOMPLETE_BUNDLES: 'UPDATE_INCOMPLETE_BUNDLES',
  GET_INCOMPLETE_BUNDLES: 'GET_INCOMPLETE_BUNDLES',
  ALL_MASTERDATA_LISTS_V2: 'ALL_MASTERDATA_LISTS_V2',
  SILHOUETEE_KEYS: 'SILHOUETEE_KEYS',
  CORRECTIVE_REASONS: 'CORRECTIVE_REASONS',
  HEALTH_CHECK: 'HEALTH_CHECK',
  SILHOUTTE_IMAGE: 'SILHOUTTE_IMAGE',
  SILHOUTTE_DOWNLOAD: 'SILHOUTTE_DOWNLOAD',
  GET_SERVER_DEFECTIVES: 'GET_SERVER_DEFECTIVES',
  VALIDATE_UNDO: 'VALIDATE_UNDO',
  BACK_UP: 'BACK_UP',
  RESTORE_APP_STATE_FOR_BACKED_UP_BCTX: 'RESTORE_APP_STATE_FOR_BACKED_UP_BCTX',
  UPLOAD_DEFECT_IMAGES: 'UPLOAD_DEFECT_IMAGES',
  GET_IMAGE_URLS_BY_IDS: 'GET_IMAGE_URLS_BY_IDS',
  GET_ROAMING_QC_TRANSACIONS: 'GET_ROAMING_QC_TRANSACIONS',
  GET_PER_PIECE_TAG_DETAILS: 'GET_PER_PIECE_TAG_DETAILS',
  GET_RFID_TAG_DETAILS: 'GET_RFID_TAG_DETAILS',
  GET_PER_PIECE_LINE_IN_TRANSACTIONS: 'GET_PER_PIECE_LINE_IN_TRANSACTIONS',
  GET_PER_PIECE_LINE_IN_TRANSACTIONS_FOR_WIP_END_STATIONS: 'GET_PER_PIECE_LINE_IN_TRANSACTIONS_FOR_WIP_END_STATIONS',
  GET_SILHOUETTE_OPERATIONS: 'GET_SILHOUETTE_OPERATIONS',
  GET_TAG_HISTORY: 'GET_TAG_HISTORY',
  LOGOUT_ACK: 'LOGOUT_ACK',
  GET_PER_PIECE_TAG_HISTORY: 'GET_PER_PIECE_TAG_HISTORY',
  GET_BUNDLE_TAG_HISTORY: 'GET_BUNDLE_TAG_HISTORY',
  GET_CUTBANK_SUBJECTS: 'GET_CUTBANK_SUBJECTS',
  GET_CUTBANK_CUT_TAG: 'GET_CUTBANK_CUT_TAG',
  GET_CUTBANK_TRANSACTION_LOG: 'GET_CUTBANK_TRANSACTION_LOG',
  GET_CUTBANK_ACTIVITY_LOG: 'GET_CUTBANK_ACTIVITY_LOG',
  GET_CUTBANK_TAG_VALIDATION: 'GET_CUTBANK_TAG_VALIDATION',
  GET_CUTBANK_TRANSACTION_UNDO_VALIDATION: 'GET_CUTBANK_TRANSACTION_UNDO_VALIDATION',
  GET_CUTBANK_TRANSACTION_UNDO_VALIDATION_WITH_BCTX: 'GET_CUTBANK_TRANSACTION_UNDO_VALIDATION_WITH_BCTX',
  DELETE_CUTBANK_TRANSACTION_LOG: 'DELETE_CUTBANK_TRANSACTION_LOG',
  UNDO_LINE_IN_EVENT_FROM_CUTBANK_OUT: 'UNDO_LINE_IN_EVENT_FROM_CUTBANK_OUT',
  BULK_SAVE_CUTBANK_IN_TRANSACTIONS: 'BULK_SAVE_CUTBANK_IN_TRANSACTIONS',
  GET_BUNDLE_TAG_DETAILS: 'GET_BUNDLE_TAG_DETAILS',
  CHECK_IF_COMPONENT_SCAN_ENABLED: 'CHECK_IF_COMPONENT_SCAN_ENABLED',
  GET_CUTBANK_COMPONENT_TAG: 'GET_CUTBANK_COMPONENT_TAG',
  BULK_SAVE_COMPONENT_TAG_TRANSACTIONS: 'BULK_SAVE_COMPONENT_TAG_TRANSACTIONS',
  BULK_EDIT_COMPONENT_TAG_QTY: 'BULK_EDIT_COMPONENT_TAG_QTY',
  GET_CUTBANK_COMPONENT_TAG_VALIDATION: 'GET_CUTBANK_COMPONENT_TAG_VALIDATION',
  UPDATE_RFID_TAGS_INFO: 'UPDATE_RFID_TAGS_INFO',
  RFID_TAG_VALIDATION: 'RFID_TAG_VALIDATION',
  BCTX_GROUP_DETAILS: 'BCTX_GROUP_DETAILS',
  NEW_BCTX_SIZE_LIST: 'NEW_BCTX_SIZE_LIST',
  TAG_DETAILS_FROM_RFID_TAGS: 'TAG_DETAILS_FROM_RFID_TAGS',
  GET_COMPONENT_TAG_BY_RFID: 'GET_COMPONENT_TAG_BY_RFID',
  BULK_COMPONENT_TAG_WIP_INFO_FROM_RFID: 'BULK_COMPONENT_TAG_WIP_INFO_FROM_RFID',
  UPDATE_RFID_TAGS_INFO_V2: 'UPDATE_RFID_TAGS_INFO_V2',
  GET_TAG_INFO_FROM_RFID_TAG: 'GET_TAG_INFO_FROM_RFID_TAG',
  FETCH_PRODUCTION_REASON_LIST: 'FETCH_PRODUCTION_REASON_LIST',
  GET_SESSION_BLOCKS_WITH_REASONS: 'GET_SESSION_BLOCKS_WITH_REASONS',
  SAVE_SESSION_BLOCK_REASONS: 'SAVE_SESSION_BLOCK_REASONS',
};

type TInputAppEndPoints = typeof InputAppEndPoints;
type TInputAppEndPointsTypes = keyof TInputAppEndPoints;

@Injectable({ providedIn: 'root' })
export class InputAppEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TInputAppEndPoints = {
    GET_BCTX: '',
    SAVE_EVENT: '',
    RESTORE_APP_STATE: '',
    TO_BE_RECTIFIED: '',
    RESTORE_TO_BE_RECTIFIED_COUNTS: '',
    ALL_MASTERDATA_LISTS: '',
    UPDATE_INCOMPLETE_BUNDLES: '',
    GET_INCOMPLETE_BUNDLES: '',
    ALL_MASTERDATA_LISTS_V2: '',
    SILHOUETEE_KEYS: '',
    HEALTH_CHECK: '',
    SILHOUTTE_IMAGE: '',
    SILHOUTTE_DOWNLOAD: '',
    GET_SERVER_DEFECTIVES: '',
    VALIDATE_UNDO: '',
    BACK_UP: '',
    RESTORE_APP_STATE_FOR_BACKED_UP_BCTX: '',
    CORRECTIVE_REASONS: '',
    UPLOAD_DEFECT_IMAGES: '',
    GET_IMAGE_URLS_BY_IDS: '',
    GET_ROAMING_QC_TRANSACIONS: '',
    GET_PER_PIECE_TAG_DETAILS: '',
    GET_RFID_TAG_DETAILS: '',
    GET_PER_PIECE_LINE_IN_TRANSACTIONS: '',
    GET_PER_PIECE_LINE_IN_TRANSACTIONS_FOR_WIP_END_STATIONS: '',
    GET_SILHOUETTE_OPERATIONS: '',
    GET_TAG_HISTORY: '',
    LOGOUT_ACK: '',
    GET_PER_PIECE_TAG_HISTORY: '',
    GET_BUNDLE_TAG_HISTORY: '',
    GET_CUTBANK_SUBJECTS: '',
    GET_CUTBANK_CUT_TAG: '',
    GET_CUTBANK_TRANSACTION_LOG: '',
    GET_CUTBANK_TAG_VALIDATION: '',
    GET_CUTBANK_ACTIVITY_LOG: '',
    GET_CUTBANK_TRANSACTION_UNDO_VALIDATION: '',
    GET_CUTBANK_TRANSACTION_UNDO_VALIDATION_WITH_BCTX: '',
    DELETE_CUTBANK_TRANSACTION_LOG: '',
    UNDO_LINE_IN_EVENT_FROM_CUTBANK_OUT: '',
    BULK_SAVE_CUTBANK_IN_TRANSACTIONS: '',
    GET_BUNDLE_TAG_DETAILS: '',
    CHECK_IF_COMPONENT_SCAN_ENABLED: '',
    GET_CUTBANK_COMPONENT_TAG: '',
    BULK_SAVE_COMPONENT_TAG_TRANSACTIONS: '',
    BULK_EDIT_COMPONENT_TAG_QTY: '',
    GET_CUTBANK_COMPONENT_TAG_VALIDATION: '',
    UPDATE_RFID_TAGS_INFO: '',
    RFID_TAG_VALIDATION: '',
    BCTX_GROUP_DETAILS: '',
    NEW_BCTX_SIZE_LIST: '',
    TAG_DETAILS_FROM_RFID_TAGS: '',
    GET_COMPONENT_TAG_BY_RFID: '',
    BULK_COMPONENT_TAG_WIP_INFO_FROM_RFID: '',
    UPDATE_RFID_TAGS_INFO_V2: '',
    GET_TAG_INFO_FROM_RFID_TAG: '',
    FETCH_PRODUCTION_REASON_LIST: '',
    GET_SESSION_BLOCKS_WITH_REASONS: '',
    SAVE_SESSION_BLOCK_REASONS: '',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;
    this.registerVars(environment);
  }

  private registerVars(environment: TInputAppEnvironmentVars) {
    this.env_vars.GET_BCTX = this.HOST_DOMAIN_WITH_PROTOCOL + environment.bctx_services + '/api/v4/getbctx';
    this.env_vars.SAVE_EVENT = this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v3/event/save';
    this.env_vars.RESTORE_APP_STATE =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.deploy_services + '/devicestatus/v3/restore';
    this.env_vars.RESTORE_APP_STATE_FOR_BACKED_UP_BCTX =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.deploy_services + '/devicestatus/v4/restore';
    this.env_vars.TO_BE_RECTIFIED =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices/remaningdefectives';
    this.env_vars.RESTORE_TO_BE_RECTIFIED_COUNTS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices/remaningdefectivesCount';
    this.env_vars.ALL_MASTERDATA_LISTS = this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices';
    this.env_vars.GET_INCOMPLETE_BUNDLES =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices/retrieveincompletebundles';
    this.env_vars.UPDATE_INCOMPLETE_BUNDLES =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices/upsertincompletebundles';
    this.env_vars.ALL_MASTERDATA_LISTS_V2 =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/api/v1/departmentWise/operationsAndIssues';
    this.env_vars.SILHOUETEE_KEYS = this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices';
    this.env_vars.CORRECTIVE_REASONS = this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices';
    this.env_vars.HEALTH_CHECK = this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v1/event/heartbeat';
    this.env_vars.LOGOUT_ACK =
      this.HOST_DOMAIN_WITH_PROTOCOL +
      environment.event_hub +
      '/api/v1/event/devicePendingEventsSyncStatusBeforeLogout/ack';
    this.env_vars.SILHOUTTE_IMAGE =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.image_service + '/dataman/getsiluhoutteimageDashBoard';
    this.env_vars.SILHOUTTE_DOWNLOAD =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices/download';
    this.env_vars.GET_SERVER_DEFECTIVES =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/dataservices/retreiverectifieddocs/v3';
    this.env_vars.VALIDATE_UNDO = this.HOST_DOMAIN_WITH_PROTOCOL + environment.bctx_services + '/api/v4/wip/validate';
    this.env_vars.BACK_UP = this.HOST_DOMAIN_WITH_PROTOCOL + environment.deploy_services + '/devicestatus/v3/backup';

    this.env_vars.UPLOAD_DEFECT_IMAGES = this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/v1/saveImages';
    this.env_vars.GET_IMAGE_URLS_BY_IDS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/v1/getImageUrlsByIds';
    this.env_vars.GET_ROAMING_QC_TRANSACIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bctx_services + '/api/logs/rqc_transaction';
    this.env_vars.GET_PER_PIECE_TAG_DETAILS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/tags/getPieceTagByDisplayPieceTagId';
    this.env_vars.GET_RFID_TAG_DETAILS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/rfid/bctxDetailsByRfidTagsRequest';
    this.env_vars.GET_PER_PIECE_LINE_IN_TRANSACTIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bctx_services + '/api/v4/logs/transaction';
    this.env_vars.GET_PER_PIECE_LINE_IN_TRANSACTIONS_FOR_WIP_END_STATIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bctx_services + '/api/v5/logs/transaction';
    this.env_vars.GET_SILHOUETTE_OPERATIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL +
      environment.core_services +
      `/api/v1/departmentWise/bulkfetchSilhouetteOperations`;
    this.env_vars.GET_TAG_HISTORY = this.HOST_DOMAIN_WITH_PROTOCOL + environment.data_gateway + '/v2/search';
    this.env_vars.GET_PER_PIECE_TAG_HISTORY =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v1/getPerPieceTagHistory';
    this.env_vars.GET_BUNDLE_TAG_HISTORY =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v1/getBundleTagHistory';
    this.env_vars.GET_CUTBANK_SUBJECTS = this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/subjects';
    this.env_vars.GET_CUTBANK_CUT_TAG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/tags/getCutTagByDisplayCutTagId';

    this.env_vars.GET_CUTBANK_TRANSACTION_LOG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/logs/v2/transaction';
    this.env_vars.GET_CUTBANK_ACTIVITY_LOG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/logs/v2/activity';
    this.env_vars.GET_CUTBANK_TAG_VALIDATION =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/store/tag_status';
    this.env_vars.GET_CUTBANK_TRANSACTION_UNDO_VALIDATION =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/store/v2/tagvalidation';
    this.env_vars.GET_CUTBANK_COMPONENT_TAG_VALIDATION =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/store/getComponentTagStatus';
    this.env_vars.GET_CUTBANK_TRANSACTION_UNDO_VALIDATION_WITH_BCTX =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/store/v2/validationTagWithBctx';

    this.env_vars.DELETE_CUTBANK_TRANSACTION_LOG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/transaction/savetx';
    this.env_vars.UNDO_LINE_IN_EVENT_FROM_CUTBANK_OUT =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v3/event/save';
    this.env_vars.BULK_SAVE_CUTBANK_IN_TRANSACTIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/transaction/bulkSave';
    this.env_vars.GET_BUNDLE_TAG_DETAILS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/componentTag/getBundleTagDetails';
    this.env_vars.CHECK_IF_COMPONENT_SCAN_ENABLED =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/store/hasComponentTagScan/:factoryId';
    this.env_vars.GET_CUTBANK_COMPONENT_TAG =
      this.HOST_DOMAIN_WITH_PROTOCOL +
      environment.tags_services +
      '/tags/getCutBundleComponentTagByComponentDisplayTagId';
    this.env_vars.BULK_SAVE_COMPONENT_TAG_TRANSACTIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/transaction/componentTag/bulkSave';
    this.env_vars.BULK_EDIT_COMPONENT_TAG_QTY =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.store_data_services + '/componentTag/bulkUpdateQuantity';
    this.env_vars.UPDATE_RFID_TAGS_INFO =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/rfid/validateAndUpdateRFIDTagsInfo';
    this.env_vars.UPDATE_RFID_TAGS_INFO_V2 =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/v2/rfid/validateAndUpdateRFIDTagsInfo';
    this.env_vars.RFID_TAG_VALIDATION =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/rfid/isRfidMappedSearchIdTerminated';
    this.env_vars.BCTX_GROUP_DETAILS =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/factory_config_backend/ext/api/v1/bctxGroup/details';
    this.env_vars.NEW_BCTX_SIZE_LIST =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/factory_config_backend/ext/api/v1/sizeList/byBctxItems';
    this.env_vars.GET_COMPONENT_TAG_BY_RFID =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/rfid/getMappedComponentTagInfoByRfidTag';
    this.env_vars.BULK_COMPONENT_TAG_WIP_INFO_FROM_RFID =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/cpm/api/v3/bulk/getComponentWipInfoByRfid';
    this.env_vars.GET_TAG_INFO_FROM_RFID_TAG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.tags_services + '/rfid/getRfidTagInfo';
    this.env_vars.FETCH_PRODUCTION_REASON_LIST =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/api/v1/productionReasons/fetchAll';
    this.env_vars.GET_SESSION_BLOCKS_WITH_REASONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v1/sessionBlocks/getSessionBlocksWithReasons';
    this.env_vars.SAVE_SESSION_BLOCK_REASONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.event_hub + '/api/v1/sessionBlocks/saveReasons';
  }

  public getEnvVar(arg: TInputAppEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
